module.exports = __webpack_public_path__ + "static/media/ckeck-inactive.39362d59.svg";